module.exports = __webpack_public_path__ + "fonts/material-icons-sharp.4f203ef2.woff2";